import React from 'react';
import gql from 'graphql-tag';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { ChildProps } from 'react-apollo';
import {
  CoreCreditCardWalletCreateFormLayout,
} from '../schemas/rql';
import CreditCardWalletCreateForm, { CreditCardWalletCreateFormFragment } from './credit_card_wallet_create_form';
import { RCLoadingBars } from '@reverbdotcom/commons/src/rc/RCLoadingBars';
import { useCreditCardForm } from './credit_card_form_context';

type Me = CoreCreditCardWalletCreateFormLayout.Me;

type Props = ChildProps<unknown, CoreCreditCardWalletCreateFormLayout.Query>;

export function CreditCardWalletCreateFormLayout(props: Props) {
  const form = useCreditCardForm();

  if (!props.data || props.data.loading) {
    return (
      <div className="d-flex fx-justify-center mtb-1">
        <RCLoadingBars />
      </div>
    );
  }

  const defaultBillingAddress = findPrimaryAddress(
    props.data.me,
  );

  return (
    <CreditCardWalletCreateForm
      form={form}
      defaultBillingAddress={defaultBillingAddress}
      countries={props.data.countries.countries}
    />
  );
}

function findPrimaryAddress(me: Me) {
  const shippingAddresses = me?.shippingAddresses || [];
  const shippingAddress = shippingAddresses.find(address => address.primary);

  return shippingAddress || {};
}

const withQuery = withGraphql<Props>(
  gql`
    query Core_CreditCardWallet_CreateFormLayout {
      countries {
        countries {
          countryCode
          name
          subregionRequired
          subregions {
            code
            name
          }
        }
      }
      me {
        uuid
        shippingAddresses {
          primary
        }
        ...CreditCardWalletCreateFormFields
      }
    }
    ${CreditCardWalletCreateFormFragment}
  `,
);

export default withQuery(CreditCardWalletCreateFormLayout);
